module.exports = __webpack_public_path__ + "static/img/4049bp-1.ebafeac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/4049bp-1.svg
// module id = Nbt6
// module chunks = 0